


























import { Component, Mixins, } from "vue-property-decorator";
import { IAiPromptSyntax } from "../../../../../domain/externalSystem";
import { SyntaxEditorMixin } from "./mixins";

@Component
export default class AiSyntaxPromptEditor extends Mixins(SyntaxEditorMixin) {
  writePropertyWhenValid: (writer: (source: IAiPromptSyntax) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IAiPromptSyntax) => T, defaultValue: T) => T;

  get prompt(): string {
    return this.readPropertyOrDefault(s => s.prompt, null);
  }

  set prompt(value: string) {
    this.writePropertyWhenValid(s => s.prompt = value);
    this.$nextTick(() => this.updateSource());
  }

  get filter(): string {
    return this.readPropertyOrDefault(s => s.filter, null);
  }

  set filter(value: string) {
    this.writePropertyWhenValid(s => s.filter = value);
    this.$nextTick(() => this.updateSource());
  }
  get isFilterEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isFilterEnable, null);
  }

  set isFilterEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.isFilterEnable = value);
    this.$nextTick(() => this.updateSource());
  }

  get promptStyle(): any {
    return {
      backgroundColor: this.shouldInputPrompt ? this.noticeIndicationBackgroundColor : null,

      // IE用の指定
      // placeholderの文字色はCSS変数(--placeholder-color)を使って指定しているがIEでは使えない
      // IEはinputで指定した文字色がplaceholderの文字色になっているため残している
      color: this.shouldInputPrompt ? this.noticeIndicationColor : null,
    };
  }

  get shouldInputPrompt(): boolean {
    return !this.prompt;
  }

  get filterStyle(): any {
    return {
      backgroundColor: this.shouldInputFilter ? this.noticeIndicationBackgroundColor : null,

      // IE用の指定
      // placeholderの文字色はCSS変数(--placeholder-color)を使って指定しているがIEでは使えない
      // IEはinputで指定した文字色がplaceholderの文字色になっているため残している
      color: this.shouldInputFilter ? this.noticeIndicationColor : null,
    };
  }

  get shouldInputFilter(): boolean {
    return this.isFilterEnable && !this.filter;
  }

  createSyntax(): string {
    return "{ prompt ? { " + this.prompt + " } "
      + (this.isFilterEnable ? "filter ? { " + this.filter + " }" : "")
      + "}";
  }

  get isSyntaxValid(): boolean {
    return !!this.prompt
      && (!this.isFilterEnable || (this.isFilterEnable && !!this.filter));
  }

  updateSource(): void {
    this.writePropertyWhenValid(s => {
      s.value = this.createSyntax();
      s.isValid = this.isSyntaxValid;
    });
  }
}
